import { defineMessages } from 'react-intl';

/** The head of Charts (design navigation-v2 e 5a): one title over the five tabs. */
export const chartsMessages = defineMessages({
  title: { id: 'app.sml.charts.title', defaultMessage: 'Charts' },
  subtitle: {
    id: 'app.sml.charts.subtitle',
    defaultMessage: 'What moves on playlists across 10+ services, for any artist, track or playlist.',
  },
});

/**
 * The old page titles of the chart pages. The web shows "Charts" now; the native apps still read
 * these ids (`scripts/music24-native/i18n-keys.txt`), so they stay in the catalogue.
 */
export const chartsLegacyMessages = defineMessages({
  artistsTitle: { id: 'app.sml.artists.header.title', defaultMessage: 'Artists' },
  tracksTitle: { id: 'app.sml.tracks.header.title', defaultMessage: 'Tracks' },
  playlistsTitle: { id: 'app.sml.playlists.header.title', defaultMessage: 'Playlists' },
  marketsCrumb: { id: 'app.sml.breadcrumbs.markets', defaultMessage: 'Markets' },
  marketsTitle: { id: 'app.sml.markets.header.title', defaultMessage: 'Where your audience listens' },
  marketsSubtitle: {
    id: 'app.sml.markets.header.countriesSubtitle',
    defaultMessage: 'Where your followed catalogue is heard, country by country.',
  },
});

/** The long line of a Charts tab, in its panel head under the tabs (design navigation-v2 e 5b). */
export const chartsTabLeadMessages = defineMessages({
  playlists: {
    id: 'app.sml.playlists.header.subtitle',
    defaultMessage: 'The editorial and algorithmic playlists shaping discovery — and which are heating up.',
  },
});
